export default function()
{
return[
    {name:'AIRBUS',logo:'airbus.png', id:1},
    {name:'SQLI',logo:'sqli.png', id:2}
  ]
}